var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chart-wrapper" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center" },
      [
        _vm.title || _vm.showLabels
          ? _c("div", { staticClass: "d-flex flex-column" }, [
              _vm.title
                ? _c("h4", { staticClass: "font-weight-bold mb-2" }, [
                    _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showLabels
                ? _c(
                    "div",
                    { staticClass: "flex-shrink-0 mr-3" },
                    [
                      _c(
                        "ScrollShadowContainer",
                        {
                          attrs: {
                            "max-height": "170px",
                            "shadow-height": "8px",
                            "shadow-color": "rgba(248, 249, 250, 0.9)",
                          },
                        },
                        _vm._l(_vm.legendItems, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "small border-light",
                              class:
                                index !== _vm.legendItems.length - 1
                                  ? "border-bottom"
                                  : "",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between p-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center flex-grow-1",
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "mr-2 flex-shrink-0 p-1 rounded",
                                        style: {
                                          backgroundColor: item.color,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-truncate",
                                          attrs: { title: item.label },
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ml-2 font-weight-bold flex-shrink-0",
                                    },
                                    [_vm._v(_vm._s(item.percentage) + "%")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "embed-responsive embed-responsive-1by1",
            style: { "max-height": _vm.options?.maxHeight ?? "200px" },
          },
          [
            _c("canvas", {
              ref: "canvas",
              staticClass: "embed-responsive-item",
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }